import { Component, Input, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ButtonClasses } from '../../../../enums/styles/buttonClasses.enum';
import { ButtonThemes } from '../../../../enums/styles/buttonThemes.enum';
import { RotationPositions } from '../../../../enums/styles/rotationPositions.enum';
import { RotationSteps } from '../../../../enums/styles/rotationStepsObj.enum';
import { Directions } from '../../../../enums/styles/rotationDirections.enum';

@Component({
    selector: 'app-button-bar-rounded',
    templateUrl: './button-bar-rounded.component.html',
    styleUrls: ['./button-bar-rounded.component.scss'],
    animations: [
        trigger('rotatedState', [
            state('false', style({
                transform: 'rotate({{initialDeg}}deg)',
            }), { params: { initialDeg: 0 } }),
            state('true', style({
                transform: 'rotate({{finalDeg}}deg)',
            }), { params: { finalDeg: 0 } }),
            transition('true => false', animate('500ms ease')),
            transition('false => true', animate('500ms ease')),
        ]),
    ],
    host: {
        '[style.width]': 'fitToContainer ? "100%" : ""',
    },
    standalone: false
})
export class ButtonBarRoundedComponent {
  @Input() fitToContainer = false;
  @Input() text: string;
  @Input() isOpen = false;
  @Input() secondText: string;
  @Input() icon = 'expand_more';
  @Input() disabled = false;
  @Input() rotation = true;
  @Input() direction = 'left';
  @Input() initialPosition = RotationPositions[0];
  @Input() steps = 2;
  @Input() buttonTheme = ButtonThemes.Secondary;

  @Output() clicked = new EventEmitter();

  getButtonClasses() {
    const classesArr = [];
    classesArr.push(ButtonClasses[this.buttonTheme]);
    if (this.fitToContainer) {
      classesArr.push('fit-to-container');
    }
    return classesArr;
  }

  get renderedText() {
    if (this.isOpen && this.secondText) {
      return this.secondText;
    }
    return this.text;
  }
  get getCurrentState() {
    if (this.rotation) {
      return this.isOpen;
    }
    return false;
  }

  get finalDegrees() {
    const calculatedDegrees = Math.abs(RotationPositions[this.initialPosition] - RotationSteps[this.steps]);
    if (this.direction === Directions.Right) {
      return calculatedDegrees === 0 ? 360 : +calculatedDegrees;
    } else {
      return -calculatedDegrees;
    }
  }

  get initialDegrees() {
    return RotationPositions[this.initialPosition];
  }

  onClick() {
    this.clicked.emit(this.isOpen);
  }
}
